
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from 'react-hook-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faCheck, faClose, faEye, faHome, faPlug, faPlus } from "@fortawesome/free-solid-svg-icons";
import { Badge, Breadcrumb, Button, Card, Form, Table } from '@themesberg/react-bootstrap';
import { confirmDeleteToast, sendError, sendSuccess, status } from "../helpers/Helper";
import { API_URL_ENDPOINT } from "../appsetting";
import CustomPagination from "../components/CustomPagination";
import { useNavigate } from "react-router-dom";
import { Routess } from "../Routes/routes";
import { useApi } from "../helpers/useApi";
import OffCanvas from "../components/OffCanvas";
import { Accordion } from "react-bootstrap";

export const Kyc = () => {
  const callApi = useApi();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [showDetail, setShowDetail] = useState(false);

  const [selectedData, setSelectedData] = useState({})
  const [documentID, setSelectedDocumentID] = useState(0)
  const [rejectReason, setRejectReason] = useState("");
  
  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState({
    items: [],
    pageNo: 1,
    pageSize: 10,
    totalPage: 0,
    totalRecords: 0,
  });

  useEffect(() => {
    getData();
  }, [])

  useEffect(() => {
    const delay = setTimeout(() => {
        if(isTyping){
          setIsTyping(false);
          getData(1);
        }
    }, 300);

    return () => clearTimeout(delay);
  }, [searchTerm]);


  const handlePageChange = (newPage) => {
    getData(newPage);
  }

  const getData = async (cp = null) => {
    try {
      setDataLoading(true);
      const filters = [];
      if (searchTerm) filters.push(`SearchText:${searchTerm}`)
      const queryParams = [
        filters.length ? `filters=${filters.join(",")}` : null,
        `pageNo=${cp ?? data.pageNo}`,
        `pageSize=${data.pageSize}`,
        `orderBy=lastUpdate`,
        `sortOrder=desc`
      ].filter(Boolean).join("&");

      const response = await callApi(API_URL_ENDPOINT.KYC + `?${queryParams}`);
      if (response.status) {
        var ddata = response.data;
        setData(ddata);
        if(showDetail){
          const sd = ddata.items.find(item => item.id === selectedData.id);
          if (sd) {
            // console.log("Selected:", selectedData);
            setSelectedData(sd);
            setShowDetail(true);
          }
        }
      }
    } catch {
      setData({
        items: [],
        pageNo: 1,
        pageSize: 10,
        totalPage: 0,
        totalRecords: 0,
      });
    } finally {
      setDataLoading(false);
    }
  }

  const handleView = (id) => {
      const selectedData = data.items.find(item => item.id === id);
      if (selectedData) {
        // console.log("Selected:", selectedData);
        setSelectedData(selectedData);
        setShowDetail(true);
      } else {
        // console.warn("No data found for ID:", id);
        sendError("No data found")
      }
  }


  const submitKycAction = async (id, action) => {
    try {
      const payload ={
        "sectionID": id,
        "rejectionReason": rejectReason,
        "status": action
      }
      const response = await callApi(API_URL_ENDPOINT.KYC,{
        method : "PUT",
        data : payload,
      });
      if (response.status) {
        sendSuccess(response.message)
        getData()
      }else{
        throw new Error(response.message || "Something Went Wrong")
      }
    } catch(ex) {
        sendError(ex.message)
    } finally {
      
    }
  }



  return (
    <>
<OffCanvas
  show={showDetail}
  placement="end"
  handleClose={() => setShowDetail(false)}
  width="40%"
  title="KYC Verification"
>
  <div className="py-0">
    <div className="mb-2 d-flex justify-content-between align-item-center">
      <div>
      <strong>Name:</strong> <span>{selectedData?.fullName || "-"}</span>
      </div>
      <div>
      {status(selectedData.kycStatus)}
      </div>
    </div>
    <div className="mb-2">
      <strong>Mobile No.:</strong> <span>{selectedData?.phoneNumber || "-"}</span>
    </div>
    <div className="mb-3">
      <strong>Type:</strong> <span>{selectedData?.clientType || "-"}</span>
    </div>

    <hr />
    <Accordion defaultActiveKey="0" className="custom-accordion">
    {selectedData?.sections?.length > 0 ? (
      selectedData.sections.map((section, sIndex) => (
      <Accordion.Item eventKey={sIndex} key={sIndex}>
        <Accordion.Header>
          <div className="w-100 d-flex justify-content-between me-3">
            {section.sectionType}
             <div>{status(section.status)}</div>
          </div>
        </Accordion.Header>
        <Accordion.Body className="border">
            {/* {section.documents?.map((doc, dIndex) => ( */}
              <div className="col-12">
                <div className="">
                  <div className="d-flex justify-content-between align-items-center">
                      <p className="text-center m-0">{section.documentTitle}</p>
                      <p style={{fontSize:12}} className="text-center text-dark m-0">{section.createdAt}</p>
                  </div>
                  <div className="mt-2 text-center">
                    <img
                      src={section.documentPath}
                      alt={section.documentTitle}
                      className="img-fluid rounded m-auto"
                      style={{
                        width: section?.sectionType === "Selfie" ? "180px" : "100%",
                        maxHeight: section?.sectionType === "Selfie" ? "280px" : "200px",
                        // maxHeight: "200px"
                      }}
                    />
                  </div>

                  {section.rejectionReason && (
                    <div className="border-danger border rounded-2 px-2 mt-3">
                      <p className="text-danger m-0 fw-bold">Rejection Reason</p>
                      <p className="text-danger m-0" style={{fontSize:12}}>{section.rejectionReason}</p>
                    </div>
                  )}

                  {documentID != section.id && section.status== "InProgress" && (
                  <div className="mt-3 d-flex align-items-center justify-content-center  gap-2">
                    <button
                      className="btn btn-success btn-sm"
                      onClick={() => submitKycAction(section.id, "Approved")}
                      >
                      <FontAwesomeIcon icon={faCheck} className="me-1" />
                      Approve
                    </button>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => setSelectedDocumentID(section.id)}
                      >
                      <FontAwesomeIcon icon={faBan} className="me-1" />
                      Reject
                    </button>
                  </div>
                  )}

                  {/* Show Reject Reason Input if this doc is being rejected */}
                  {documentID === section.id && section.status== "InProgress" && (
                    <div className="mt-2">
                      <textarea
                        className="form-control shadow-none"
                        rows="2"
                        placeholder="Enter reject reason"
                        value={rejectReason || ""}
                        onChange={(e) => setRejectReason(e.target.value)}
                      />
                      <button
                        className="btn btn-success btn-sm mt-2"
                        onClick={() => submitKycAction(section.id, "Rejected")}
                      >
                        Submit Reason
                      </button>
                      <button
                        className="btn btn-danger btn-sm mt-2 ms-1"
                        onClick={() => setSelectedDocumentID(0)}
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                </div>
              </div>
            {/* ))} */}
        </Accordion.Body>
      </Accordion.Item>
        
        
      ))
    ) : (
      <div className="text-muted">No KYC documents uploaded.</div>
    )}
    </Accordion>


  </div>
</OffCanvas>

      <div className="justify-content-between d-flex flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            {/* <Breadcrumb.Item>NPSP</Breadcrumb.Item> */}
            <Breadcrumb.Item active>KYC Requests</Breadcrumb.Item>
          </Breadcrumb>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">KYC Requests</h4>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <Form.Control value={searchTerm}onChange={(e) => { setSearchTerm(e.target.value); setIsTyping(true); }} type="text" className="shadow-none" placeholder={"Search..."} />
        </div>
      </div>

      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="pb-0">
          {dataLoading ? (
            <div className="text-center my-3">
              <span className="spinner-border text-primary" role="status"></span>
            </div>
          ) : (
            <Table responsive className="table-centered table-nowrap rounded mb-0">
              <thead className="thead-light">
                <tr>
                  <th className="border-0 text-center">#</th>
                  <th className="border-0 text-center">Name</th>
                  <th className="border-0 text-center">Phone Number</th>
                  <th className="border-0 text-center">Type</th>
                  <th className="border-0 text-center">Status</th>
                  <th className="border-0 text-center">Last Update</th>
                  <th className="border-0 text-end pe-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.items?.length > 0 ? (
                  data?.items.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center align-middle">
                        {(data.pageNo - 1) * data.pageSize + index + 1}
                      </td>
                      <td className="fw-bold align-middle text-center">{item.fullName || "-"}</td>
                      <td className="fw-bold align-middle text-center">{item.phoneNumber || "-"}</td>
                      <td className="fw-bold align-middle text-cemter">{item.clientType}</td>
                      <td className="fw-bold align-middle text-center">{status(item.kycStatus)}</td>
                      <td className="fw-bold align-middle text-center">{item.updatedAt || "-"}</td>
                      <td className="text-end align-middle">
                      <Button variant="primary" className="btn-sm" onClick={() => handleView(item.id)}><FontAwesomeIcon icon={faEye} className="me-1"/> View</Button>
                        {/* <Button onClick={handleDelete} variant="danger" className="btn-sm">Remove</Button> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">No Data Found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
          <div className="d-flex justify-content-end">
            <CustomPagination totalPages={data.totalPage} loading={dataLoading} onPageChange={handlePageChange} />
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
